////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import TableNested from '../../../components/Table/components/TableNested'

//////STYLED//////
const LogExtranetManagerNestedWrapper = styled.td`
	display: ${(props) => (props.isVisible ? 'table-cell' : 'none')};
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
	& > div {
		max-width: calc(100vw - 350px);
		position: sticky;
		left: 100px;
		min-width: max-content;
	}
	& > div:before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -1px;
		box-shadow: 3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div:after {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		right: -1px;
		box-shadow: -3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div > div {
		min-width: max-content;
	}
`
const DisplayLogWrapper = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`

const DisplayLog = styled.div`
	display: flex;
	max-width: 600px;
	align-items: center;
	justify-content: center;
`
//////STYLED//////

const LogExtranetManagerNested = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: translations['page__logAdmin__tableHeader_message'],
		isInNestedTable: true,
	}

	let arrayMessage = [{ message: props.row.message }]

	const columns = [
		{
			dataHook: 'message',
			headerName: translations['page__logAdmin__tableHeader_message'],
			isAuthorize: true,
			component: (props) => (
				<DisplayLogWrapper>
					<DisplayLog>{props.row.message}</DisplayLog>
				</DisplayLogWrapper>
			),
		},
	]

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<LogExtranetManagerNestedWrapper colSpan={props.colspan} isVisible={props.stateToggleNested}>
			<div>
				<div>{<TableNested inputColumns={columns} inputData={arrayMessage} inputConfig={config} />}</div>
			</div>
		</LogExtranetManagerNestedWrapper>
	)
}

LogExtranetManagerNested.propTypes = {}

LogExtranetManagerNested.defaultPropTypes = {}

export default LogExtranetManagerNested
